import { useNotificationsStore } from "../stores/use-notifications-store.js";
import { useNotificationsMountedGuard } from "./use-notifications-mounted-guard.js";

/**
 * Lê os dois slices do inbox de notificações do Zustand.
 * Requer NotificationsProvider (guarda de escopo).
 *
 * @returns {{
 *   pendingItems: Object[],
 *   readItems: Object[],
 *   unreadCount: number,
 *   pendingIsLoading: boolean,
 *   pendingError: string|null,
 *   readIsLoading: boolean,
 *   readError: string|null,
 *   pendingNextCursor: string|null,
 *   readNextCursor: string|null,
 *   reload: (params?: { limit?: number|string }, requestOptions?: RequestInit) => Promise<*>,
 *   fetchMorePending: () => Promise<*>,
 *   fetchRead: (params?: { limit?: number|string }) => Promise<*>,
 *   fetchMoreRead: () => Promise<*>,
 *   notifications: Object[],
 *   isLoading: boolean,
 *   error: string|null,
 * }}
 */
export function useNotifications() {
  useNotificationsMountedGuard();

  const pendingItems = useNotificationsStore((state) => state.pendingItems);
  const readItems = useNotificationsStore((state) => state.readItems);
  const unreadCount = useNotificationsStore((state) => state.unreadCount);
  const pendingIsLoading = useNotificationsStore((state) => state.pendingIsLoading);
  const pendingError = useNotificationsStore((state) => state.pendingError);
  const readIsLoading = useNotificationsStore((state) => state.readIsLoading);
  const readError = useNotificationsStore((state) => state.readError);
  const pendingNextCursor = useNotificationsStore((state) => state.pendingNextCursor);
  const readNextCursor = useNotificationsStore((state) => state.readNextCursor);
  const fetchPending = useNotificationsStore((state) => state.fetchPending);
  const fetchMorePending = useNotificationsStore((state) => state.fetchMorePending);
  const fetchRead = useNotificationsStore((state) => state.fetchRead);
  const fetchMoreRead = useNotificationsStore((state) => state.fetchMoreRead);

  return {
    pendingItems,
    readItems,
    unreadCount,
    pendingIsLoading,
    pendingError,
    readIsLoading,
    readError,
    pendingNextCursor,
    readNextCursor,
    reload: fetchPending,
    fetchMorePending,
    fetchRead,
    fetchMoreRead,
    // retrocompat — notifications-inbox.js usa notifications/isLoading/error
    notifications: pendingItems,
    isLoading: pendingIsLoading,
    error: pendingError,
  };
}
